export const organizationsActionTypes = {
  fetch: 'ORGANIZATIONS_FETCH',
  fetchSuccess: 'ORGANIZATIONS_FETCH_SUCCESS',
  fetchFail: 'ORGANIZATIONS_FETCH_FAIL',
};
